import _extends from "@babel/runtime/helpers/esm/extends";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

import React from 'react';
import { buttonSizes, buttonReset, buttonVariants } from "./Button";
import styled, { css } from 'styled-components';
import VisuallyHidden from '@reach/visually-hidden';
import { theme, whenHovered } from "../../theme";
import { focusStyles, hoverTransition } from "../Interactive/mixins";
import { ghostVariant } from "./ghost";
import { useSharedHoverContext } from "../SharedHover/SharedHoverContext";
import { mergeProps } from '@react-aria/utils';
export var baseIconButtonStyles = css(["", ";padding:0;width:", ";height:", ";outline:none;align-items:center;position:relative;border-radius:", ";display:inline-flex;vertical-align:middle;justify-content:center;flex-shrink:0;", ";", ";"], buttonReset, function (p) {
  return "".concat(buttonSizes[p.$size], "px");
}, function (p) {
  return "".concat(buttonSizes[p.$size], "px");
}, theme.radii[6], hoverTransition, focusStyles);
export var iconButtonGhostVariant = css(["will-change:transform;", ";", ""], ghostVariant(), function (p) {
  if (p.$color === 'secondary') {
    return css(["color:", ";", "{color:", ";}"], theme.colors.icon.primary, whenHovered, theme.colors.icon.interactive.hover);
  }

  return css([""]);
});
var StyledButton = styled.button.withConfig({
  displayName: "IconButton__StyledButton",
  componentId: "vapor__sc-1jml11s-0"
})(["", ";", ";", ";"], baseIconButtonStyles, function (p) {
  return buttonVariants[p.$variant];
}, function (p) {
  return p.$variant === 'ghost' && (p.$color === 'secondary' || p.$color === 'neutral') && iconButtonGhostVariant;
});
export var IconButton = React.forwardRef(function (_ref, ref) {
  var as = _ref.as,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'secondary' : _ref$color,
      icon = _ref.icon,
      label = _ref.label,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'medium' : _ref$size,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'contained' : _ref$variant,
      other = _objectWithoutProperties(_ref, ["as", "color", "icon", "label", "size", "variant"]);

  var iconChild = icon;

  var _useSharedHoverContex = useSharedHoverContext(),
      onEnterTarget = _useSharedHoverContex.onEnterTarget,
      onLeaveTarget = _useSharedHoverContex.onLeaveTarget,
      enabled = _useSharedHoverContex.enabled;

  function onMouseEnter(e) {
    onEnterTarget(e.currentTarget.getBoundingClientRect());
  }

  function onMouseLeave() {
    onLeaveTarget();
  }

  return /*#__PURE__*/React.createElement(StyledButton, _extends({
    $color: color,
    $sharedHoverEnabled: enabled && variant === 'ghost',
    $size: size,
    $variant: variant,
    as: as,
    ref: ref
  }, mergeProps(other, variant === 'ghost' && {
    onMouseEnter: onMouseEnter,
    onMouseLeave: onMouseLeave
  })), /*#__PURE__*/React.createElement(VisuallyHidden, null, label), React.cloneElement(iconChild, _objectSpread({
    'aria-hidden': true,
    fill: 'none'
  }, iconChild.props || {})));
});